import Stepper from './Stepper'
import WithStepperImages from './containers/WithStepperImages'

export default WithStepperImages(Stepper)
